import User from "../models/User";
import AgencyOpportunity from "../models/AgencyOpportunity";


const fetchSupplierDashboard = async ({queryKey, signal}) => {
    const SupplierStatsRequest = TB.request(
        TB.api_endpoint(`/api/talent-dashboard`)
    )

    let response = await SupplierStatsRequest.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data')) {
        throw new Error('Something went wrong')
    }

    return response.success.data;
}
const fetchTalentResourcesForJobBoard = async ({queryKey, signal}) => {
    const clientId = queryKey[1];

    const FetchAllForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/users/supplied-talent/byo`)
    );

    let response = await FetchAllForClientRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.users')) {
        throw new Error('Something went wrong')
    }

    return User.makeMany(
        response.success.data.users
    );
}

const fetchOpportunityForAgency = async ({queryKey, signal}) => {
    const oppId = queryKey[1] || {}
    return AgencyOpportunity.fetchDetails(oppId, {signal})
}
const fetchAllSupplierOpportunities = async ({queryKey, signal}) => {
    const params = queryKey[1] || {}
    return AgencyOpportunity.fetchAllForSupplierResourceManager(params, {signal})
}
const fetchAllSupplierTalentResources = async ({queryKey, signal}) => {
    const clientId = queryKey[1];

    const FetchAllForClientRequest = TB.request(
        TB.api_endpoint(`/api/clients/${clientId}/users`), {type: laravel.user_types.talent}
    );

    let response = await FetchAllForClientRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.users')) {
        throw new Error('Something went wrong')
    }

    return TB.filter(User.makeMany(
        response.success.data.users
    ), user => user.isTalent());
}
const fetchServiceOfferingTags = async ({queryKey, signal}) => {
    const {search} = queryKey[1] || {search: ''};

    const FetchServiceTagsRequest = TB.request(
        TB.api_endpoint(`/api/service-tags`), {search}
    );

    let response = await FetchServiceTagsRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.service_tags')) {
        throw new Error('Something went wrong')
    }


    return TB.orderBy(TB.values(TB.reduce(response.success.data.service_tags, (result, value, key) => {
        if (!value.category) {
            return result
        }
        if (result[value.category?.id]) {
            result[value.category?.id].service_tags.push(TB.pick(value, ['id', 'name', 'description', 'display_index']));
            result[value.category?.id].service_tags = TB.orderBy(result[value.category?.id]?.service_tags, 'display_index', 'asc')
        }else {
            result[value.category?.id] = {
                ...value.category,
                service_tags: [
                    TB.pick(value, ['id', 'name', 'description', 'display_index'])
                ]
            }
        }
        return result
    }, {})), 'display_index', 'asc');
}

const fetchPartnerPrograms = async ({queryKey, signal}) => {
    const {search} = queryKey[1] || {search: ''};

    const FetchPartnerProgramsRequest = TB.request(
        TB.api_endpoint(`/api/partner-programs`), {search}
    );

    let response = await FetchPartnerProgramsRequest.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.partner_programs')) {
        throw new Error('Something went wrong')
    }


    return TB.orderBy(TB.values(TB.reduce(response.success.data.partner_programs, (result, value, key) => {
        if (!value.category) {
            return result
        }
        if (result[value.category?.id]) {
            result[value.category?.id].programs.push(TB.pick(value, ['id', 'name', 'display_index']));
            result[value.category?.id].programs = TB.orderBy(result[value.category?.id]?.programs, 'display_index', 'asc')
        }else {
            result[value.category?.id] = {
                ...value.category,
                programs: [
                    TB.pick(value, ['id', 'name', 'display_index'])
                ]
            }
        }
        return result
    }, {})), 'display_index', 'asc');
}
const fetchSupplierTalentResource = ({queryKey, signal}) => {
    const talentUserId = queryKey[1] || {};  // queryKey[0] is the original query key

    return User.fetchTalentSupplierResource(talentUserId, {signal});
}

export {
    fetchSupplierDashboard,
    fetchAllSupplierOpportunities,
    fetchSupplierTalentResource,
    fetchAllSupplierTalentResources,
    fetchTalentResourcesForJobBoard,
    fetchOpportunityForAgency,
    fetchServiceOfferingTags,
    fetchPartnerPrograms
}